import { createStore, combineReducers } from 'redux';
import { numberOfClicksReducer, appGlobalReducer } from "state-management/reducers";

const rootReducer = combineReducers({
    numberOfClicks: numberOfClicksReducer,
    appGlobal: appGlobalReducer,
});

export const store = createStore(rootReducer);








